import React, {FC} from 'react';
import {IconButton, makeStyles, Typography} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";
import {EditOutlined as EditIcon, Home as HomeIcon} from "@material-ui/icons";
import {useHistory, useRouteMatch} from "react-router-dom";

const useStyles = makeStyles(() => ({
    captionContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    nameIcon: {
        paddingTop: 3.4,
        paddingRight: 4
    }
}))

export const AddressDisplay: FC<{ loading: boolean; address?: string; className?: string; editIdentifier?: string, label?: string }> = ({
                                                                                                                                            label,
                                                                                                                                            editIdentifier,
                                                                                                                                            address,
                                                                                                                                            className,
                                                                                                                                            loading
                                                                                                                                        }) => {
    const classes = useStyles();
    const history = useHistory();
    const {url} = useRouteMatch();
    return (
        <div className={className}>
            <div className={classes.captionContainer}>
                <Typography variant="caption" color="textSecondary" className={classes.nameIcon}>
                    <HomeIcon color="inherit" fontSize="inherit"/>
                </Typography>
                <Typography variant="caption" color="textSecondary">
                    {label ?? 'Adresse'}
                </Typography>
            </div>
            {loading
                ? <Skeleton width={224}/>
                : (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}>
                        <Typography>
                            {address}
                        </Typography>
                        {editIdentifier && (
                            <IconButton size="small"
                                        onClick={() => history.replace(url + '?mode=edit#' + editIdentifier)}>
                                <EditIcon fontSize="inherit"/>
                            </IconButton>)}
                    </div>
                )
            }
        </div>
    );
}